export default __webpack_public_path__ + "static/media/action-heading.2747fb7d.png";